export default {
  title: 'Bestellung bei {{company}}',
  button: {
    title: "Bezahle mit",
  },
};
